export default __webpack_public_path__ + "static/media/logo.9aa5c2f8.png";